import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EpdkBadgeComponent } from './badge.component';

@NgModule({
  imports: [CommonModule],
  declarations: [EpdkBadgeComponent],
  exports: [EpdkBadgeComponent]
})
export class EpdkBadgeModule { }